'use client'

import { InView } from 'react-intersection-observer'

import { useAbTest, useTrackAbTestCallback } from '@marketplace-web/feature-flags/ab-tests-data'

type Props = {
  children: React.ReactNode
}

const FeedContentWrapper = ({ children }: Props) => {
  const reversedMixedItemsBlocks = useAbTest('item_page_similar_items_removal_v2')
  const trackAbTest = useTrackAbTestCallback()

  const handleCrossSellingChannelsView = (inView: boolean) =>
    inView && trackAbTest(reversedMixedItemsBlocks)

  return (
    <InView
      as="div"
      className="u-ui-margin-top-medium"
      onChange={handleCrossSellingChannelsView}
      triggerOnce
    >
      {children}
    </InView>
  )
}

export default FeedContentWrapper
